import { ChangeDetectorRef, Pipe, PipeTransform, effect, inject } from '@angular/core';
import { I18nStore } from '../store/i18n.store';

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private readonly i18n = inject(I18nStore);
  private readonly cdr = inject(ChangeDetectorRef);

  constructor() {
    // Trigger change detection when language changes
    effect(() => {
      this.i18n.lang(); // Subscribe to language changes
      this.cdr.markForCheck();
    });
  }

  transform(key: string, params?: Record<string, string>): string {
    return this.i18n.t(key, params);
  }
}
